import ScoreResults from "@/components/checkup/ScoreResults";
import RecapResults from "@/components/checkup/RecapResults";

export default function ResultsStage({ result, error, pathway, assessmentId, onRetry }) {
  if (error) {
    return (
      <div className="py-20 text-center" data-testid="results-error">
        <p className="text-lg font-semibold text-navy max-w-md mx-auto">{error}</p>
        <button onClick={onRetry} data-testid="results-retry-button" className="mt-6 min-h-[52px] rounded-full bg-navy text-cream font-extrabold text-sm tracking-widest px-8 hover:bg-navy-light transition-colors">
          TRY AGAIN
        </button>
      </div>
    );
  }
  if (!result) {
    return (
      <div className="py-24 flex flex-col items-center gap-4 text-navy" data-testid="results-loading">
        <div className="w-10 h-10 rounded-full border-4 border-sand border-t-gold animate-spin" />
        <p className="font-semibold">Preparing your results…</p>
      </div>
    );
  }
  const Results = pathway.resultType === "score" ? ScoreResults : RecapResults;
  return <Results result={result} pathway={pathway} assessmentId={assessmentId} />;
}
